module.exports = __webpack_public_path__ + "malta.svg?b127219b107d8c7180f20aae51c54031";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/malta.svg
// module id = 225
// module chunks = 10